import {Action, createReducer, on} from '@ngrx/store';
import * as CalculatorActions from './calculator.actions';

export const calculatorFeatureKey = 'calculator';

export interface State {
  inSaving: boolean;
  saved: boolean;
  error: string;
  update: {
    orderID: number,
    inUpdate: boolean,
    success: boolean,
    error: string
  };
}

export const initialState: State = {
  inSaving: false,
  saved: false,
  error: null,
  update: {
    orderID: null,
    inUpdate: false,
    success: false,
    error: null
  }
};


export const reducer = createReducer(
  initialState,

  on(CalculatorActions.loadCalculators, state => state),
);

